<template>
  <div class="record-view-card">
    <div class="record-card-container">
      <!-- 音频图标 -->
      <div class="audio-icon">
        <i class="icon-gongpai-ai-line t-iconfont"></i>
      </div>

      <!-- 信息 -->
      <div class="record-info">
        <h4 class="record-title">智能硬件录音</h4>
        <p class="record-time">{{ uploadTitle }}</p>
      </div>

      <!-- 复选框 -->
      <div class="checkbox">
        <i class="icon-checkbox-circle-line t-iconfont"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import xbb from '@xbb/xbb-utils'

defineOptions({
  name: 'RecordViewCard'
})

const props = defineProps({
  uploadTime: {
    type: String,
    default: ''
  }
})

const uploadTitle = computed(() => {
  return xbb.formatTime(props.uploadTime, 'yyyy-MM-dd HH:mm')
})
</script>

<style lang="scss" scoped>
.record-view-card {
  .record-card-container {
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid #f2f3f5;
    border-radius: 20px;

    .audio-icon {
      width: 40px;
      height: 40px;
      background-color: #f2f3f5;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      .icon-gongpai-ai-line {
        color: #a871e3;
        font-size: 20px;
      }
    }

    .record-info {
      flex: 1;

      .record-title {
        font-size: 14px;
        font-weight: 500;
        color: #323233;
        margin: 0 0 4px 0;
      }

      .record-time {
        font-size: 13px;
        color: #969799;
        margin: 0;
      }
    }

    .checkbox {
      margin-left: 12px;

      .icon-checkbox-circle-line {
        font-size: 20px;
        color: #00c241;
      }
    }
  }
}
</style>
